import React from 'react';
import JournalEntryAttributesKey from 'domain/finance/journalEntry/shared/field/JournalEntryAttributesKey';
import { ControlledList, DataGridLayout } from 'framework/list';
import { TextField, useFieldHelper } from 'framework/ui/field';
import { isObject } from 'lodash';

const EXCLUDED_ATTRIBUTES = [
  'employeeName',
  'employeeAlias',
  'businessObjectType',
  'invoiceId',
  'revertedOriginalJournalEntryId',
  'leaveId',
  'office',
  'projectId',
  'accountId',
  'sowId',
];

const JournalEntryAttributesList = ({ source }: { source: string }) => {
  const { getValue } = useFieldHelper({ source });
  const attributes = (getValue() as any) || {};
  const attributesItems = Object.entries(attributes).reduce(
    (acc: { key: string; value: string }[], [key, value]: any) => {
      if (EXCLUDED_ATTRIBUTES.includes(key) || (key === 'businessObjectId' && attributes.businessObjectType)) {
        return acc;
      }

      return [...acc, { key, value: isObject(value) ? JSON.stringify(value, null, 2) : String(value) }];
    },
    [],
  );

  return (
    <ControlledList data={{ items: attributesItems, totalPages: 1, totalElements: attributesItems.length }}>
      <DataGridLayout
        sxTableWrapper={{
          '& table.MuiTable-root': {
            minWidth: '1080px',
          },
        }}
      >
        <JournalEntryAttributesKey source="key" label="Key" width="50%" />
        <TextField source="value" label="Value" width="50%" />
      </DataGridLayout>
    </ControlledList>
  );
};

export default JournalEntryAttributesList;
